import sendMessage from "./message"
import setAttr from "./attr"
import setState from "./state"
import upsert from "./upsert"
import submit from "./submit"
import customActions from "conf/actions"

export default { sendMessage, setAttr, setState, upsert, submit, ...customActions }
